import React, { useEffect } from 'react';
import { Title, Wrap } from '../../styled';
import { Space } from '@gr-monorepo/common/ui';
import Chart from './Chart';
import ImproveResult from './ImproveResult';
import { useMunicipalityStatistics } from '../../useMunicipalityStatistics';
import LoaderComponent from 'features/shared/Loader';
import { Widget } from 'models/widgetMultiStageOlympiad';

const MunicipalityStatistics = ({id, widget}: {id: number, widget: Widget}) => {
  const { pendingMunicipalityRating, municipalityRating,  olympStatus } = useMunicipalityStatistics(widget)
  
  return (
    pendingMunicipalityRating ? (
      <LoaderComponent />
    ) : municipalityRating?.length ? (
      <>
        <Space axis="vertical" size={40} />
        <Wrap>
          <Title>Региональный рейтинг муниципалитетов по количеству участников олимпиады</Title>
          <Space axis="vertical" size={16} />
          {municipalityRating && (
            <>
              <Chart rows={municipalityRating} color={'#dbb2ff'} />
              <div style={{ fontSize: '14px' }}>Чтобы посмотреть количество участников, наведите курсор на график</div>
              <Space axis="vertical" size={24} />
              {olympStatus === 'current' && <ImproveResult id={id} widget={widget}/>}
            </>
          )}
        </Wrap>
      </>
    ) : null)

};

export default MunicipalityStatistics;
